import {React, useState} from "react";
import { socket } from '../../utils';
import { useSelector } from 'react-redux';
import "./PostBackButtons.scss";

const PostbackButton = ({ title, payload, onPostback, theme, isReplied }) => {
    const { engagement, user, ui, common } = useSelector(state=>state);
    const config = ui?.config?.attributes;

    // const [disabledButtons, setDisabledButtons] = useState([]);

    // console.log(disabledButtons);

    if (title.includes('null')) {
        return null;
     }

    // Handle the button click
    const handleClick = (index) => {
        onPostback(payload);
        
    };
    
  const _sendRichMessage = ()=>{
    // let elementText = {
    //     text: payload,
    //     textFormat:'PLAINTEXT'
    // } 

    // let body = {
    //     elementType: "text",
    //     elementText: elementText,
    //     payload: null,
    //     // richMediaPayload: {}
    // }

    let normalizedPayload = payload.substring(1, payload.length-1);

    let richMedia = {
        "selectedAction": {
            "type": "reply",
            "payload": normalizedPayload
        }
    }

    let body = {
        "elementType": "reply",
        "elementText": {
            "text": title,
            "textFormat": "PLAINTEXT"
        },
        "payload": normalizedPayload,
        "richMediaPayload": richMedia
    }
    let message = {
        body: body,
        senderName: user.data.displayName,
        providerDialogId: engagement.params.CustomerVerified == "true" ? ((user.data.chProviderDialogId !== undefined) ? user.data.chProviderDialogId : user.data.providerDialogId) : user.data.providerDialogId,
        providerSenderId: engagement.params.CustomerVerified == "true" ? ((user.data.chProviderSenderId !== undefined) ? user.data.chProviderSenderId : user.data.providerSenderId) : user.data.providerSenderId,
        engagementParam: user.data.engagementParameters,
        customerIdentifiers: user.data.customerIdentifiers,
    }


    let s = socket.getInstance()
    s.emit("message",message,(res)=>{
        // setIsEmojiShown(false)
        if(res.hasError){
            console.log(res);
        //   engagementExists(engagement.data?.engagementId)
        }
    })

    // setDisabledButtons([...disabledButtons, index]);
}
  return (
    <button disabled={isReplied} onClick={_sendRichMessage} payload={payload} className={theme} >
    {title}
    </button>
  );
};
export default PostbackButton;
